export default "__VITE_ASSET__XAcrJay5__"